import { render, staticRenderFns } from "./UnitManage.vue?vue&type=template&id=4fa2aa37&scoped=true&"
import script from "./UnitManage.vue?vue&type=script&lang=js&"
export * from "./UnitManage.vue?vue&type=script&lang=js&"
import style0 from "./UnitManage.vue?vue&type=style&index=0&id=4fa2aa37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2aa37",
  null
  
)

export default component.exports